const data = [
  { value: 1, label: "Carrera" },
  { value: 5, label: "Posgrados" },
  { value: 7, label: "Ebooks" },
  { value: 11, label: "Carrera Corta" },
];

export default data;
